import { render, staticRenderFns } from "./SlideDeckResources.vue?vue&type=template&id=49b3846d"
import script from "./SlideDeckResources.vue?vue&type=script&lang=ts"
export * from "./SlideDeckResources.vue?vue&type=script&lang=ts"
import style0 from "./SlideDeckResources.vue?vue&type=style&index=0&id=49b3846d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports